var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLive = function SvgLive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8184 8.39999C17.9272 10.3882 17.9272 13.6117 15.8184 15.6M8.18162 15.5999C6.07279 13.6117 6.07279 10.3882 8.18162 8.39996M5.63604 18C2.12132 14.6863 2.12132 9.3137 5.63604 6M18.364 6.00004C21.8787 9.31374 21.8787 14.6863 18.364 18M13.8 12C13.8 12.9372 12.9941 13.697 12 13.697C11.0059 13.697 10.2 12.9372 10.2 12C10.2 11.0627 11.0059 10.3029 12 10.3029C12.9941 10.3029 13.8 11.0627 13.8 12Z",
    stroke: "#8075E6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Live.5af66c49c387d1afd957a43d100522bf.svg";